import { render, staticRenderFns } from "./PaymentMethodEdit.vue?vue&type=template&id=13413acf&scoped=true&"
import script from "./PaymentMethodEdit.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13413acf",
  null
  
)

export default component.exports